import React from 'react';

import Skeleton from '../../../Skeleton';
import { Container } from './styles';

interface ShimmerCourseCardProps {
  courseViewType: string;
  animationDelay?: number;
  /** Silhueta da fileira nova — ver o comentário em styles.ts. */
  fluid?: boolean;
}

const CourseCard: React.FC<ShimmerCourseCardProps> = ({
  courseViewType,
  animationDelay,
  fluid = false,
}) => (
  <Container type={courseViewType} $fluid={fluid}>
    <Skeleton className="bg-skeleton" animationDelay={animationDelay} />
    <span>
      <Skeleton
        className="progress-bar-wrapper-skeleton"
        animationDelay={animationDelay}
      >
        <Skeleton
          className="progress-bar-skeleton"
          animationDelay={animationDelay}
        />
      </Skeleton>
    </span>
  </Container>
);

export default CourseCard;
